module.exports = __webpack_public_path__ + "static/media/48364687_2308766225865222_413861459504660480_o-thumb.8b3e3a4b.jpg";